import anime from 'animejs';
import AOS from 'aos';
import barba from '@barba/core';

import { closeMenu, determineCurrentPage } from './menu';
import { calculateBreaksAndColors, removeHeaderWhite } from './logo';
import { addHoverListeners, removeHoverListeners } from './hover-carousel';
import { addAccordionListeners, removeAccordionListeners } from './accordion';
import { addEmailListener } from './email';

const hamburgerBtn = document.querySelector('.header-hamburger__button');

const newPageCallback = () => {
    determineCurrentPage(); // re-assign currentPageItem variable
    calculateBreaksAndColors(); // figure out vertical breakpoints for logo color change
    addHoverListeners(); // adds event listeners if user is on page with hover carousel
    addAccordionListeners(); // adds event listeners if user is on page with hover carousel
    addEmailListener();

    // move the page name near the hamburger into sight
    anime({
        targets: '.header-hamburger__page-name',
        opacity: 1,
        translateY: 0,
        duration: 200,
        easing: 'linear'
    });
};

const defaultTransition = {
    // Leave hook with destructured `data.current`
    leave({ current, next }) {
        removeHoverListeners(); // remove event listeners on hover carousels (if they exist)
        removeAccordionListeners(); // remove event listeners on mobile accordions (if they exist)
        // Create your tween
        const promiseArr = [];
        const expanded = hamburgerBtn.getAttribute('aria-expanded') === 'true' || false;
        const containerDuration = expanded ? 0 : 300;

        const bodyTransition = anime({
            // [data-barba="container"] of current page
            targets: current.container,
            duration: containerDuration,
            opacity: [1, 0],
            easing: 'linear'
        });
        promiseArr.push(bodyTransition.finished);

        // move the menu off-screen to the left if the menu is expanded; reset hamburger
        if (expanded) {
            const menuTransition = anime({
                targets: '.nav',
                translateX: '-100%',
                duration: 400,
                easing: 'cubicBezier(0.420, 0.000, 0.535, 0.995)'
            });
            promiseArr.push(menuTransition.finished);

            const hamburgerTransition = anime({
                targets: '.header-hamburger__line--mover',
                scaleX: 1,
                duration: 1500
            });
            // Don't need to push the hamburger transition to the array because it can spill over to
            // the next state.
        } else {
            // Determine the first part of the path (e.g., "work")
            const firstPathRegEx = /^\/([^\/]*).*$/;
            const currentFirstPath = current.url.path.replace(firstPathRegEx, '$1');
            const nextFirstPath = next.url.path.replace(firstPathRegEx, '$1');

            // only trigger if the first part of the path (e.g., "work") changes
            if (currentFirstPath !== nextFirstPath) {
                // fade out the page name near the hamburger
                anime({
                    targets: '.header-hamburger__page-name',
                    opacity: 0,
                    translateY: -50,
                    duration: 200,
                    easing: 'linear'
                });
            }
        }

        const allTransitions = Promise.all(promiseArr);

        // Return when all promises are finished
        return allTransitions;
    },
    // Leave hook with destructured `data.next`
    enter({ next, trigger }) {
        if (trigger !== 'back' && trigger !== 'forward') {
            removeHeaderWhite();
            window.scrollTo(0, 0); // scroll to top of page
        }
        closeMenu(false); // useAnimation = false (a different animation is used before the page loads)
        const mainTransition = anime({
            // [data-barba="container"] of next page
            targets: next.container,
            duration: 500,
            opacity: [0, 1],
            easing: 'linear',
            complete: newPageCallback
        });
    },
    after() {
        AOS.refreshHard(); // refresh where AOS transitions should occur
    }
};
// Init barba.js with your transition.
barba.init({
    transitions: [defaultTransition]
});
